import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DANHSACHKIEMKHO } from "../actions/DanhSachKiemKho/actionTypes";
import {
  getListDanhSachKiemKhoSuccess,
  getListDanhSachKiemKhoFailure,
} from "../actions/DanhSachKiemKho";
import DanhSachKiemKhoApi from "../service/danhSachKiemKhoApi";

function* getListDanhSachKiemKho(action) {
  try {
    const response = yield call(DanhSachKiemKhoApi.list1, action.dataSearch);
    if (response.ok) {
      yield put(getListDanhSachKiemKhoSuccess(response.data));
    } else {
      yield put(getListDanhSachKiemKhoFailure());
    }
  } catch (error) {
    yield put(getListDanhSachKiemKhoFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHKIEMKHO, getListDanhSachKiemKho);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
